import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const onExpired = () => setUser(false);
    window.addEventListener("auth:expired", onExpired);
    // Returning from Google sign-in: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return () => window.removeEventListener("auth:expired", onExpired);
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
    return () => window.removeEventListener("auth:expired", onExpired);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    sessionStorage.removeItem("started");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout, isAdmin: user?.role === "admin", can: (k) => user?.role === "admin" || !!user?.perms?.[k] }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
